import {useEffect, useState} from "react";
import toast from "react-hot-toast";
import {ProductService} from "../product/Service";
import Select from "react-select";
import {OrderService} from "./Service";

const CreateOrder = ({user, refresh}) => {
    const [productService] = useState(new ProductService());
    const [orderService] = useState(new OrderService());
    const [loading, setLoading] = useState(false);
    const [productOptions, setProductOptions] = useState([]);

    // Cart

    const [product, setProduct] = useState(null);
    const [username, setUsername] = useState("");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [designation, setDesignation] = useState("");
    const [cardEmail, setCardEmail] = useState("");

    // Billing info
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [email, setEmail] = useState('');
    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine2, setAddressLine2] = useState('');
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');

    const handleSubmit = async (e) => {
      e.preventDefault();
        setLoading(true);
        const data = {
            cart: {
                product: product.value,
                quantity: 1,
                username: username,
                info: {
                    name: name,
                    phoneNumber: phone,
                    designation: designation,
                    email: cardEmail,
                }
            },
            billingInfo: {
                firstName,
                lastName,
                phoneNumber: phoneNo,
                postcode: pinCode,
                email,
                addressLine1,
                addressLine2,
                country,
                state,
                city
            },
            user: user
        };

        console.log(data);

        const res = await orderService.add(data);
        if (res) {
            e.target.reset();
            setProduct(null);
            setUsername("");
            setName("");
            setPhone("");
            setDesignation("");
            setCardEmail("");
            setFirstName('');
            setLastName('');
            setPhoneNo('');
            setPinCode('');
            setEmail('');
            setAddressLine1('');
            setAddressLine2('');
            setCountry('');
            setState('');
            setCity('');
            toast.success("Order created successfully");
            refresh();
        }
        setLoading(false);
    }


    useEffect(() => {
        const getCart = async () => {
            const res = await productService.all();
            const products = [];
            if (res) {
                for (let i = 0; i < res.length; i++) {
                    products.push({label: res[i].title, value: res[i]._id});
                }
            }
            console.log(products);
            setProductOptions(products);
        }
        getCart();
    }, [productService]);


    return (
        <>
            <div className="card mb-5">
                <div className="card-header p-3">
                    <h5 className="card-title">Create Order</h5>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                                <h3>Add Card</h3>
                            </div>
                            <div className="mb-3 col-sm-12 col-md-12">
                                <label htmlFor="type" className="form-label">Product</label>
                                <Select
                                    name="product"
                                    options={productOptions}
                                    value={product}
                                    onChange={setProduct} required={true} />
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Username <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="username" name="username" placeholder="Username" value={username}
                                           onChange={(e) => setUsername(e.target.value)} required={true}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Name <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="name" name="name" placeholder="Name" value={name}
                                           onChange={(e) => setName(e.target.value)} required={true}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Phone number <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="phone" name="phone" placeholder="Phone Number" value={phone}
                                           onChange={(e) => setPhone(e.target.value)} required={true}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Email <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="email" className="form-control" id="email" name="email" placeholder="Email" value={cardEmail}
                                           onChange={(e) => setCardEmail(e.target.value)} required={true}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Designation <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="designation" name="designation" placeholder="Designation" value={designation}
                                           onChange={(e) => setDesignation(e.target.value)} required={true}/>
                                </div>
                            </div>



                        </div>
                        <div className="row mt-5">
                            <div className="col-sm-12 col-md-12">
                                <h3>Billing Information</h3>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">First Name <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="name" name="name" placeholder="First Name" value={firstName}
                                           onChange={(e) => setFirstName(e.target.value)} required={true}/>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Last Name</label>
                                    <input type="text" className="form-control" id="lastName" name="lastName" placeholder="Last Name" value={lastName}
                                           onChange={(e) => setLastName(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Phone Number <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="phoneNumber" name="phoneNumber" placeholder="Phone Number" value={phoneNo}
                                           onChange={(e) => setPhoneNo(e.target.value)} />
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Email <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="email" className="form-control" id="email" name="email" placeholder="Email" value={email}
                                           onChange={(e) => setEmail(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Address Line 1 <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="line1" name="line1" placeholder="Address Line 1" value={addressLine1}
                                           onChange={(e) => setAddressLine1(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Address Line 2</label>
                                    <input type="text" className="form-control" id="line2" name="line2" placeholder="Address Line 2" value={addressLine2}
                                           onChange={(e) => setAddressLine2(e.target.value)} />
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Country <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="country" name="country" placeholder="Country" value={country}
                                           onChange={(e) => setCountry(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">State <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="state" name="state" placeholder="State" value={state}
                                           onChange={(e) => setState(e.target.value)} />
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">City <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="city" name="city" placeholder="City" value={city}
                                           onChange={(e) => setCity(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Pin Code <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="pinCode" name="pinCode" placeholder="Pin Code" value={pinCode}
                                           onChange={(e) => setPinCode(e.target.value)}/>
                                </div>
                            </div>


                        </div>

                        <div className={'d-flex'}>
                            <button type="submit" className="btn btn-primary me-2" disabled={loading}>{loading &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"/>} Submit
                            </button>
                            <button type="button" className="btn btn-secondary me-2" disabled={loading} onClick={() => {
                                window.history.back();
                            }}>{loading &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"/>} Back
                            </button>
                        </div>

                    </form>

                </div>
            </div>
        </>
    );
}


export default CreateOrder;
